import { Box, Checkbox, Table } from '@betterment/samba-react';

import { BillingPlan } from '../../../../graphql/schema';
import { ApplyCashFirstBillingModalTableProps } from '../data';

export const ApplyCashFirstBillingModalTable: React.FC<ApplyCashFirstBillingModalTableProps> = ({
  billingPlans,
  handleCheckboxChange,
  selectedOptions,
}) => {
  return (
    <Box css={{ maxHeight: '300px', overflow: 'auto' }}>
      <Box>
        <Table>
          <Table.Header>
            <Table.Row />
          </Table.Header>
          <Table.Body>
            {billingPlans.map((billingPlan: BillingPlan) => (
              <Table.Row key={billingPlan.id} data-testid="billingPlanRow">
                <Table.Cell>
                  <Checkbox>
                    <Checkbox.Control
                      appearance="default"
                      onCheckedChange={() => handleCheckboxChange(billingPlan.id)}
                      checked={selectedOptions.includes(billingPlan.id)}
                    />
                    <Checkbox.Label>{billingPlan.name}</Checkbox.Label>
                  </Checkbox>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row />
          </Table.Footer>
        </Table>
      </Box>
    </Box>
  );
};
